export const MANIFEST_LOADER_PLUGIN_NAME = `web-extension:manifest`;
export const LABELED_STEP_PLUGIN_NAME = `web-extension:labeled-step`;
export const MULTIBUILD_COMPLETE_PLUGIN_NAME = `web-extension:multibuild`;
export const BUNDLE_TRACKER_PLUGIN_NAME = `web-extension:bundle-tracker`;
export const HMR_REWRITE_PLUGIN_NAME = `web-extension:hmr-rewrite`;
